import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { PenTool, Mic2, Lightbulb, Home, Dumbbell, List, Users } from 'lucide-react';

interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  to: string;
  active?: boolean;
}

function NavItem({ icon, label, to, active }: NavItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center px-2 py-2 xl:px-4 xl:py-2.5 rounded-lg transition-all duration-200 ${
          isActive || active
            ? 'dark:bg-navy-800 dark:text-white bg-[#D5DBDB] text-gray-900 font-semibold shadow-sm'
            : 'dark:text-gray-400 dark:hover:bg-navy-800/90 dark:hover:text-white text-gray-700 hover:bg-[#D5DBDB]/90 hover:text-gray-900'
        }`
      }
    >
      <span className="flex items-center justify-center w-5 h-5 mr-1.5 xl:mr-2.5">
        {icon}
      </span>
      <span className="font-medium">{label}</span>
    </NavLink>
  );
}

export default function Navigation() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      {/* Desktop Navigation */}
      <nav className="hidden lg:flex items-center divide-x divide-gray-200 dark:divide-gray-700/30">
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<Home size={18} />}
            label="Home"
            to="/"
            active={currentPath === '/'}
          />
        </div>
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<Users size={18} />}
            label="Community"
            to="/community"
            active={currentPath === '/community'}
          />
        </div>
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<PenTool size={18} />}
            label="Write"
            to="/write"
          />
        </div>
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<Lightbulb size={18} />}
            label="Ideas"
            to="/ideas"
          />
        </div>
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<Dumbbell size={18} />}
            label="Exercises"
            to="/exercises"
          />
        </div>
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<Mic2 size={18} />}
            label="Practice"
            to="/practice"
          />
        </div>
        <div className="px-1 xl:px-2">
          <NavItem
            icon={<List size={18} />}
            label="Set List"
            to="/setlist"
          />
        </div>
      </nav>


    </>
  );
}